import { render, staticRenderFns } from "./KioskLanguageSelector.vue?vue&type=template&id=0c6d2378"
import script from "./KioskLanguageSelector.vue?vue&type=script&lang=js"
export * from "./KioskLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./KioskLanguageSelector.vue?vue&type=style&index=0&id=0c6d2378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports